cv.TeamProjectsRowEmptyView = Marionette.LayoutView.extend({
  template : cv.Templates['team/projects_row_empty'],

  bindings : {
  },

  events : {
  },

  initialize: function(){
    console.log('TeamProjectsRowEmptyView initialized');
  },

  templateHelpers: function(){
  },

  
  onAttach: function(){
  }
});
